module.exports = __webpack_public_path__ + "files/SPIADI2026 - RÉA EXPL AUR - Fiche Patient.55f6deeab093207bb3d7a49b5368832a.pdf";